import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {LoginService} from "../services/login/login.service";

@Injectable({
  providedIn: 'root',
})
export class LoguinGuard implements CanActivate {

  constructor(private loginService : LoginService, private router: Router) {
  }

  canActivate(): boolean {
    if (this.loginService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/']); // Redirige a la página de login si no está autenticado
      return false;
    }
  }


}
